import { useState } from "react";

import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import Loading from "common/blocks/Loading";
import UIIcon from "common/blocks/UIIcon";
import useModalContext from "common/providers/modal/useModalContext";
import { getFinanceExampleSidePanel } from "services/motorpoint/financeExampleSidePanel";

import FinanceExampleSidePanel from ".";
import styles from "./FinanceExampleSidePanel.module.scss";
import FinanceExampleSidePanelFooter from "./footer";

const cx = classNames.bind(styles);

export type FinanceExampleSidePanelErrorProps = {
    vehicleId: number;
};

const FinanceExampleSidePanelError = (props: FinanceExampleSidePanelErrorProps) => {
    const { useSidebar } = useModalContext();
    const { closeSidebar, openSidebar } = useSidebar();
    const [loading, setLoading] = useState<boolean>(false);

    const retry = async (
        event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement | MouseEvent> | undefined
    ) => {
        event?.preventDefault();
        setLoading(true);

        const financeExample = await getFinanceExampleSidePanel({ vehicleId: props.vehicleId });

        if (!financeExample) {
            setLoading(false);
            return;
        }

        closeSidebar();

        openSidebar({
            title: financeExample.Title,
            content: {
                component: () => <FinanceExampleSidePanel {...financeExample} />,
                footerComponent: () => (
                    <FinanceExampleSidePanelFooter
                        vehicleAdvertUri={financeExample.VehicleAdvertUri}
                    />
                ),
            },
        });
    };

    return (
        <div className={cx("financeExampleError")}>
            <UIIcon className={cx("center")} svgProps={{ className: cx("icon") }} icon="Warning" />
            <span className={cx("errorTitle")}>Oops!</span>
            <span className={cx("errorDescription")}>
                We weren&apos;t able able to get the finance example figures at the moment.
            </span>
            <span className={cx("errorRetry")}>
                Please &quot;Retry&quot; or close and try again later.
            </span>
            {loading ? (
                <Loading />
            ) : (
                <Button theme="primary" fullWidth onClick={retry} ariaLabel="Retry">
                    Retry
                </Button>
            )}
        </div>
    );
};

export default FinanceExampleSidePanelError;
